import { Icon, type IconProps } from "@chakra-ui/react";

function FileIcon(props: IconProps) {
	return (
		<Icon
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M2.3999 4C2.3999 1.79086 4.19076 0 6.3999 0H14.3999L21.5999 7.2V20C21.5999 22.2091 19.809 24 17.5999 24H6.3999C4.19076 24 2.3999 22.2091 2.3999 20V4Z"
				fill="url(#paint0_linear_4367_1255)"
			/>
			<path
				d="M14.3999 0L21.5999 7.2H18.3999C16.1908 7.2 14.3999 5.40914 14.3999 3.2V0Z"
				fill="#EAECF0"
			/>
			<g clipPath="url(#clip0_4367_1255)">
				<path
					d="M8 13.6H22.4M8 16.8H22.4M8 20H22.4M8 23.2H19.2"
					stroke="#344054"
					strokeWidth="1.5"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</g>
			<defs>
				<linearGradient
					id="paint0_linear_4367_1255"
					x1="11.9999"
					y1="0"
					x2="11.9999"
					y2="24"
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#F9FAFB" />
					<stop offset="1" stopColor="#EDF0F3" />
				</linearGradient>
				<clipPath id="clip0_4367_1255">
					<rect
						width="9.6"
						height="9.6"
						fill="white"
						transform="translate(7.19995 9.60001)"
					/>
				</clipPath>
			</defs>
		</Icon>
	);
}

export default FileIcon;
